import { useState } from 'react';
import { WHATSAPP_URL } from '../data/siteData';

// ── SVG ICON SYSTEM ──
export function Icon({ name, className = "w-5 h-5" }) {
  const icons = {
    whatsapp: <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347"/>,
    arrow: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></>,
    check: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></>,
    chevronDown: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></>,
    globe: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h.5A2.5 2.5 0 0020 5.5V3.935" /></>,
    shield: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></>,
    star: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></>,
    plus: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></>,
    calendar: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></>,
    location: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></>,
    mail: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></>,
    phone: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 7V5z" /></>,
    clock: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></>,
    users: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" /></>,
  };
  const isFill = ['whatsapp'].includes(name);
  return (
    <svg className={className} viewBox="0 0 24 24" fill={isFill ? "currentColor" : "none"} stroke={isFill ? "none" : "currentColor"}>
      {icons[name]}
    </svg>
  );
}

// ── WHATSAPP STICKY ──
export function WhatsAppButton() {
  return (
    <a href={WHATSAPP_URL} target="_blank" rel="noreferrer"
      className="wa-pulse fixed bottom-7 right-7 z-50 w-[58px] h-[58px] rounded-full bg-[#25D366] flex items-center justify-center hover:scale-110 transition-transform duration-200 shadow-[0_8px_24px_rgba(37,211,102,0.5)]"
      title="Chat on WhatsApp">
      <Icon name="whatsapp" className="w-7 h-7 fill-white" />
    </a>
  );
}

// ── PAGE HERO ──
export function PageHero({ breadcrumb, title, subtitle }) {
  return (
    <div className="bg-gradient-to-br from-navy-deep to-teal pt-32 pb-20 text-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 hero-grid-bg opacity-50 pointer-events-none"></div>
      <div className="max-w-3xl mx-auto relative z-10">
        <div className="flex items-center justify-center gap-2 text-xs text-white/40 mb-4">
          <span>Home</span>
          <svg className="w-3 h-3 text-gold/60" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
          <span className="text-white/60">{breadcrumb}</span>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl text-white font-semibold mb-4">{title}</h1>
        <p className="text-white/65 text-lg max-w-xl mx-auto leading-relaxed">{subtitle}</p>
      </div>
    </div>
  );
}

// ── CTA SECTION ──
export function CTASection({ title, subtitle, setPage }) {
  return (
    <section className="bg-navy py-20 relative overflow-hidden">
      <div className="absolute top-[-100px] right-[-100px] w-96 h-96 rounded-full pointer-events-none" style={{background:'radial-gradient(circle, rgba(26,122,138,0.3), transparent 70%)'}}></div>
      <div className="max-w-2xl mx-auto text-center px-4 relative z-10">
        <span className="section-tag" style={{background:'rgba(201,168,76,0.15)',color:'#E8C97A'}}>Take the First Step</span>
        <h2 className="font-display text-4xl text-white font-semibold mt-2 mb-4">{title}</h2>
        <p className="text-white/60 text-lg mb-10">{subtitle}</p>
        <div className="flex flex-wrap gap-4 justify-center">
          <button onClick={() => { setPage('contact'); window.scrollTo({top:0,behavior:'smooth'}); }} className="btn-gold">
            <Icon name="calendar" className="w-4 h-4" />
            Book Free Consultation
          </button>
          <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="btn-outline">
            <Icon name="whatsapp" className="w-4 h-4 fill-white" />
            WhatsApp Us Now
          </a>
        </div>
      </div>
    </section>
  );
}

// ── FAQ ITEM ──
export function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`border rounded-xl mb-3 overflow-hidden transition-all duration-200 ${open ? 'border-teal shadow-[0_0_0_3px_rgba(26,122,138,0.08)]' : 'border-gray-200'}`}>
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-6 py-5 text-left font-semibold text-sm text-navy cursor-pointer focus:outline-none gap-4">
        <span className="flex items-center gap-3">
          <span className={`w-6 h-6 rounded-lg flex-shrink-0 flex items-center justify-center transition-colors ${open ? 'bg-teal' : 'bg-teal/10'}`}>
            <Icon name="plus" className={`w-3 h-3 transition-all duration-300 ${open ? 'rotate-45 text-white' : 'text-teal'}`} />
          </span>
          {q}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-400 ${open ? 'max-h-56 pb-5' : 'max-h-0'}`}>
        <p className="px-6 text-sm text-gray-500 leading-relaxed">{a}</p>
      </div>
    </div>
  );
}

// ── SECTION HEADER ──
export function SectionHeader({ tag, title, subtitle, light = false }) {
  return (
    <div className="text-center max-w-2xl mx-auto mb-14">
      <span className={`section-tag ${light ? 'bg-gold/15 text-gold-light' : ''}`}>{tag}</span>
      <h2 className={`font-display text-4xl sm:text-5xl font-semibold mt-1 mb-4 ${light ? 'text-white' : 'text-navy'}`}>{title}</h2>
      {subtitle && <p className={`text-lg ${light ? 'text-white/55' : 'text-gray-500'}`}>{subtitle}</p>}
    </div>
  );
}

// ── SERVICE CARD ──
export function ServiceCard({ icon, title, desc, bullets, cta, setPage }) {
  return (
    <div className="bg-white border border-gray-100 rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_60px_rgba(11,31,58,0.12)] group relative overflow-hidden cursor-pointer">
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-teal to-teal-light scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left rounded-t-2xl"></div>
      <div className="w-14 h-14 rounded-[14px] bg-gradient-to-br from-teal/10 to-teal/5 flex items-center justify-center text-2xl mb-5">{icon}</div>
      <h4 className="font-body font-semibold text-navy text-base mb-2">{title}</h4>
      <p className="text-gray-500 text-sm leading-relaxed mb-4">{desc}</p>
      {bullets && (
        <ul className="mb-5 space-y-1.5">
          {bullets.map(b => (
            <li key={b} className="text-xs text-gray-400 flex items-start gap-2">
              <Icon name="check" className="w-3.5 h-3.5 text-teal flex-shrink-0 mt-0.5" />
              {b}
            </li>
          ))}
        </ul>
      )}
      <button onClick={() => { setPage('contact'); window.scrollTo({top:0,behavior:'smooth'}); }} className="btn-primary text-xs px-5 py-2.5">{cta}</button>
    </div>
  );
}

// ── TESTIMONIAL CARD ──
export function TestiCard({ initial, name, role, text, color }) {
  return (
    <div className="bg-white rounded-2xl p-7 shadow-card hover:-translate-y-1 hover:shadow-[0_20px_60px_rgba(11,31,58,0.12)] transition-all duration-300">
      <div className="flex gap-1 mb-4">
        {[...Array(5)].map((_, i) => <Icon key={i} name="star" className="w-3.5 h-3.5 text-gold" />)}
      </div>
      <div className="text-teal text-3xl font-serif leading-none mb-3">"</div>
      <p className="text-gray-500 text-sm leading-relaxed mb-6 italic">{text}</p>
      <div className="flex items-center gap-3">
        <div className={`w-11 h-11 rounded-full bg-gradient-to-br ${color} flex items-center justify-center font-bold text-sm text-white flex-shrink-0`}>{initial}</div>
        <div>
          <div className="font-semibold text-navy text-sm">{name}</div>
          <div className="text-xs text-gray-400">{role}</div>
        </div>
      </div>
    </div>
  );
}
